/* ===========================================================================
   OSERE — Suscripción por Treli
   Adaptado el 18 sep 2026 de `treli-subscription.js`.

   QUÉ SE TIRÓ DEL ORIGINAL, Y POR QUÉ
   -----------------------------------
   Unas 120 líneas leían la variante seleccionada rascando el DOM: `.swatch`,
   `#productSelect-option-N`, `<fieldset><legend>`, y un `fetch` a `.js` del
   producto para saber el orden de las opciones. Son los selectores del tema
   Zoa y AQUÍ NO EXISTEN NINGUNO — el widget habría mostrado «No disponible»
   siempre, sin error en consola.

   Este tema ya tiene un contrato para esto, el de `os-buy-state.js`:
     · `[data-os-variant="<id>"]` en cada control
     · evento `os:variant:change` con `detail.variantId`
   Es el mismo que usan el buybox y la barra fija, así que el widget se entera
   del cambio de tramo sin adivinar nada.

   Y SE AÑADIÓ UNA COSA QUE EL ORIGINAL NO PODÍA SABER
   ---------------------------------------------------
   En la PDP de OSERE hay una BARRA DE COMPRA FIJA anclada a
   `.os-pdp__acciones` en modo `ambos`, así que está en pantalla desde que
   carga la página. Ocultar solo los controles del buybox dejaba al cliente
   con un «Añadir al carrito» flotante mientras el panel decía «Suscribirme»:
   dos formas de comprar en pantalla a la vez, una de ellas la equivocada.
   `os-barra-compra` entra en la lista de lo que se oculta.
   =========================================================================== */
(function () {
  'use strict';

  var CLASE_OCULTO = 'os-treli-oculto';

  /* Lo que se aparta cuando el modo es suscripción. Los cuatro primeros son de
     ESTE tema; el resto son la red de Dawn por si el widget se inserta en una
     plantilla que no sea la PDP nueva. */
  var SELECTORES_NATIVOS = [
    '.os-pdp__acciones',
    'os-barra-compra',
    '.os-pdp__tramos',
    '.os-pdp__garantia',
    'product-form',
    '.product-form__buttons',
    '.shopify-payment-button',
    'quantity-input'
  ];

  function pesos(centavos) {
    if (typeof centavos !== 'number' || isNaN(centavos)) return '—';
    return '$' + Math.round(centavos / 100).toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function leerJSON(valor, porDefecto) {
    if (!valor) return porDefecto;
    try {
      return JSON.parse(valor);
    } catch (e) {
      return porDefecto;
    }
  }

  function montar(raiz) {
    if (raiz.hasAttribute('data-os-treli-montado')) return;
    raiz.setAttribute('data-os-treli-montado', '');

    var precios = leerJSON(raiz.getAttribute('data-precios-variante'), {});
    var frecuencias = leerJSON(raiz.getAttribute('data-frecuencias'), []);
    if (!frecuencias.length) return;

    var porSlug = {};
    frecuencias.forEach(function (f) { porSlug[f.slug] = f; });

    var opciones = raiz.querySelectorAll('[data-os-treli-modo]');
    var radios = raiz.querySelectorAll('input[type="radio"]');
    var panel = raiz.querySelector('[data-os-treli-panel]');
    var selFreq = raiz.querySelector('[data-os-treli-freq]');
    var selCant = raiz.querySelector('[data-os-treli-cantidad]');
    var boton = raiz.querySelector('[data-os-treli-boton]');
    var campoFreq = raiz.querySelector('[data-os-treli-campo-freq]');

    var elPrecioUnica = raiz.querySelector('[data-os-treli-precio-unica]');
    var elPrecioSub = raiz.querySelector('[data-os-treli-precio-sub]');
    var elPrecioAntes = raiz.querySelector('[data-os-treli-precio-antes]');
    var elDescuento = raiz.querySelector('[data-os-treli-descuento]');

    /* Con una sola frecuencia el desplegable no es una decisión: se oculta el
       campo entero pero el <select> sigue en el DOM, que es de donde el resto
       del código lee el valor. */
    if (frecuencias.length < 2 && campoFreq) campoFreq.hidden = true;

    var varianteId = raiz.getAttribute('data-variante-inicial') || '';

    function precioUnitarioUnica() {
      var v = precios[String(varianteId)];
      return typeof v === 'number' ? v : null;
    }

    function freqActual() {
      return selFreq && selFreq.value ? porSlug[selFreq.value] : frecuencias[0];
    }

    function cantidad() {
      var n = selCant ? parseInt(selCant.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function urlConCantidad(base, n) {
      if (!base) return null;
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'quantity=' + n;
    }

    function pintar() {
      var unitaria = precioUnitarioUnica();
      elPrecioUnica.textContent = unitaria === null ? '—' : pesos(unitaria);

      var f = freqActual();
      var n = cantidad();

      if (!f || !f.url) {
        elPrecioSub.hidden = false;
        elPrecioSub.textContent = 'No disponible';
        elPrecioAntes.hidden = true;
        elDescuento.hidden = true;
        boton.classList.add('is-inactivo');
        boton.removeAttribute('href');
        return;
      }

      boton.classList.remove('is-inactivo');
      boton.setAttribute('href', urlConCantidad(f.url, n));

      /* El precio de suscripción es opcional: sin él el widget sigue llevando
         a Treli, solo que sin cifra ni descuento. Un enlace que funciona vale
         más que un precio inventado. */
      if (typeof f.precio === 'number' && f.precio > 0) {
        var totalSub = f.precio * n;
        elPrecioSub.hidden = false;
        elPrecioSub.textContent = pesos(totalSub);

        if (unitaria) {
          var totalUnica = unitaria * n;
          if (totalSub < totalUnica) {
            elPrecioAntes.textContent = pesos(totalUnica);
            elPrecioAntes.hidden = false;
            var pct = Math.round(((totalUnica - totalSub) / totalUnica) * 100);
            if (pct > 0) {
              elDescuento.textContent = pct + '% menos';
              elDescuento.hidden = false;
            } else {
              elDescuento.hidden = true;
            }
          } else {
            elPrecioAntes.hidden = true;
            elDescuento.hidden = true;
          }
        } else {
          elPrecioAntes.hidden = true;
          elDescuento.hidden = true;
        }
      } else {
        /* Sin precio configurado NO se pinta un guion: un «—» donde va una
           cifra se lee como que algo falló. La tarjeta se queda sin precio y
           la cifra la da Treli en su pasarela, que es de donde manda. */
        elPrecioSub.textContent = '';
        elPrecioSub.hidden = true;
        elPrecioAntes.hidden = true;
        elDescuento.hidden = true;
      }
    }

    /* Se oculta con una CLASE, no con `style.display = 'none'` como el
       original: así el estado vive en la hoja y no pisa un `display` que la
       sección ya tuviera puesto — que era lo que pasaba al devolverlo, porque
       el original restauraba a cadena vacía. */
    function ocultarNativos(ocultar) {
      SELECTORES_NATIVOS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (raiz.contains(el)) return;
          el.classList.toggle(CLASE_OCULTO, ocultar);
        });
      });
    }

    function modo(nuevo) {
      opciones.forEach(function (o) {
        o.classList.toggle('is-activa', o.getAttribute('data-os-treli-modo') === nuevo);
      });
      radios.forEach(function (r) { r.checked = r.value === nuevo; });
      var esSub = nuevo === 'suscripcion';
      if (panel) panel.hidden = !esSub;
      ocultarNativos(esSub);
    }

    opciones.forEach(function (o) {
      o.addEventListener('click', function () {
        modo(o.getAttribute('data-os-treli-modo'));
      });
    });
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) modo(r.value);
      });
    });

    if (selFreq) selFreq.addEventListener('change', pintar);
    if (selCant) selCant.addEventListener('change', pintar);

    if (boton) {
      boton.addEventListener('click', function (e) {
        if (boton.classList.contains('is-inactivo') || !boton.getAttribute('href')) {
          e.preventDefault();
        }
      });
    }

    /* El contrato del tema. Una línea sustituye a las cinco estrategias de
       rastreo del original. */
    document.addEventListener('os:variant:change', function (ev) {
      if (ev.detail && ev.detail.variantId) {
        varianteId = String(ev.detail.variantId);
        pintar();
      }
    });

    /* Red por si el widget se usa donde `os-buy-state.js` no esté montado. */
    document.addEventListener('change', function (ev) {
      var control = ev.target.closest && ev.target.closest('[data-os-variant]');
      if (control) {
        varianteId = String(control.getAttribute('data-os-variant'));
        pintar();
      }
    });

    pintar();
  }

  function arrancar() {
    document.querySelectorAll('[data-os-treli]').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El personalizador reinyecta la sección al editar: sin esto el widget se
     queda muerto tras cada cambio de ajuste. */
  document.addEventListener('shopify:section:load', arrancar);
})();
